import { useCallback, useEffect, useReducer, useState } from 'react'
import NoDataImg from '../../../assets/img/no-data.gif'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import SearchIcon from '@mui/icons-material/Search'
import InputGroup from 'react-bootstrap/InputGroup'
import Pagination from '@mui/material/Pagination'
import NavBar from '../../structure/NavBar'
import dayjs, { Dayjs } from 'dayjs'
import AppleIcon from '@mui/icons-material/Apple'
import AndroidIcon from '@mui/icons-material/Android'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Form from 'react-bootstrap/Form'
import { NavBarTop } from '../../structure/NavBarTop'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import {
    updateTopHeader,
    uplodateLoading
} from '../../../redux/features/common/commonSlice'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast, showToast } from '../../constants/toaster'
import Switch from '@mui/material/Switch'
import ShowLongText from '../../custom/ShowLongText'
import Utils from '../../constants/Utils'
import InsufficientPermission from '../../custom/InSufficientPermission'
import Image from '../../custom/Image'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { formatIndianNumber } from '../../lib/formatIndianNumber'
const label = { inputProps: { 'aria-label': 'Size switch demo' } }

export const DistributionList = props => {
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [callAPi, setCallAPi] = useState('')
    const [amount, setAmount] = useState("");
    const [fixvalue, setFixValue] = useState("");
    const userData = useSelector(state => state?.userData)
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    })
    const [datalist, setDatalist] = useState([])
    const dispatch = useDispatch()
    const [page, setPage] = useState(1)

    const [statusDropdownText, setStatusDropdownText] = useState({
        id: null,
        label: "Select Status"
    });
    const [statusDropdownList, setStatusDropdownList] = useState([
        {
            id: null,
            label: "Select Status"
        },
        {
            id: "PERCENTAGE",
            label: "Percentage"
        },
        {
            id: "FIXED",
            label: "Fixed"
        }
    ]);

    const handleFilterClick = useCallback(() => {
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }, [statusDropdownText, startDate, endDate])

    const handleResetFilter = () => {
        setStartDate(null)
        setEndDate(null)
        setStatusDropdownText({
            id: null,
            label: "Select Status"
        });
        setFixValue("")
        setAmount("")
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }

    useEffect(() => {
        dispatch(updateTopHeader('Distribution Manager'))
    }, [])


    useEffect(() => {
        distributionList()
    }, [callAPi])

    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10
        })
        setCallAPi(uuidv4())
    }

    const distributionList = async () => {
        try {
            let startDateObject
            let endDateObject
            if (startDate?.toDate()) {
                let newDate = new Date(startDate?.toDate())
                newDate.setDate(newDate.getDate() + 1)
                startDateObject = newDate
            }
            if (endDate?.toDate()) {
                // Create a new Date object based on startDate
                let newDate = new Date(endDate?.toDate())
                newDate.setDate(newDate.getDate() + 1)
                endDateObject = newDate
            }
            dispatch(uplodateLoading(true))
            let postJson = {
                statusKey: statusDropdownText?.id || null,
                statusValue: fixvalue?.trim(),
                amount: amount?.trim(),
                page: pagerecord?.pageNumber - 1 || 0,
                limit: pagerecord.pageSize || 10,
                startDate: startDateObject !== null ? startDateObject : '',
                endDate: endDateObject !== null ? endDateObject : ''
            }
            let path = urls.distributionList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                setDatalist(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 10
                })
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleTransferAmount = async () => {
        try {
            dispatch(uplodateLoading(true))
            let postJson = {}
            let path = urls.transferCash
            let res = await ApiCaller.get(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                showToast(response.message)
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
            setDatalist([])
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    return (
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                <>
                    <div className='container-fluid mt--7'>
                        <div className='row'>
                            <div className='col text-left'>
                                <div className='card shadow'>
                                    <div className='card-header border-0'>
                                        <div className='row align-items-center text-left'>
                                            <div className='col'>
                                                <Link to="/referral-manager"><ArrowBackIcon /></Link>
                                                
                                                <h3 className='mb-0'>Distribution Manager </h3>
                                            </div>
                                        </div>
                                        <div className='col text-right'>
                                            {
                                                datalist?.length > 0 ?
                                                    <Button
                                                        variant="contained"
                                                        className="custom-filter-btn"
                                                        onClick={handleTransferAmount}
                                                    >
                                                        Transfer Amount
                                                    </Button>
                                                    : <></>
                                            }
                                        </div>
                                    </div>
                                    <div className='card-header border-0'>
                                        <div className='row align-items-center text-left'>
                                            <div className="col-md-2 mb-2 " style={{ marginRight: "30px" }}>
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        variant="success"
                                                        style={{
                                                            backgroundColor: "white",
                                                            color: "black",
                                                            border: "1px solid #cad1d7",
                                                            boxShadow: "none",
                                                            transform: "none",
                                                        }}
                                                        id="dropdown-basic"
                                                    >
                                                        {statusDropdownText?.label}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {statusDropdownList?.map((data, i) => {
                                                            return <>
                                                                <Dropdown.Item
                                                                    onClick={() =>
                                                                        setStatusDropdownText(data)
                                                                    }
                                                                >
                                                                    {data?.label}
                                                                </Dropdown.Item>
                                                            </>
                                                        })}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            <div className="col-md-3">
                                                <InputGroup
                                                    className="mb-2"
                                                    style={{ borderRadius: "10px" }}
                                                >
                                                    <Form.Control
                                                        disabled={statusDropdownText?.id == null ? 'disabled' : ''}
                                                        placeholder={"Enter " + statusDropdownText?.label}
                                                        value={fixvalue}
                                                        onChange={(e) => setFixValue(e.target.value)}
                                                        aria-label={statusDropdownText?.label}
                                                    />
                                                </InputGroup>
                                            </div>
                                            <div className="col-md-3">
                                                <InputGroup
                                                    className="mb-2"
                                                    style={{ borderRadius: "10px" }}
                                                >
                                                    <Form.Control
                                                        disabled={statusDropdownText?.id == null ? 'disabled' : ''}
                                                        placeholder="Enter Amount"
                                                        value={amount}
                                                        onChange={(e) => setAmount(e.target.value)}
                                                        aria-label="Amount"
                                                    />
                                                </InputGroup>
                                            </div>
                                            <div
                                                className="col-md-6 mb-3"
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DemoContainer
                                                        components={["DatePicker", "DatePicker"]}
                                                    >
                                                        <DatePicker
                                                            disableFuture
                                                            className="custom-date"
                                                            label="From Date"
                                                            value={startDate}
                                                            onChange={(newValue) => setStartDate(newValue)}
                                                            maxDate={endDate}
                                                        />
                                                        <DatePicker
                                                            disableFuture
                                                            label="To Date"
                                                            value={endDate}
                                                            onChange={(newValue) => setEndDate(newValue)}
                                                            minDate={startDate}
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </div>
                                            <div className='col-md-3 mb-2'>
                                                <Button
                                                    variant='contained'
                                                    className='custom-filter-btn'
                                                    onClick={handleFilterClick}
                                                >
                                                    Distribute Amount
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    className='ml-2 custom-filter-btn'
                                                    onClick={handleResetFilter}
                                                >
                                                    Reset
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='table-responsive'>
                                        {datalist?.length ? (
                                            <>
                                                <table className='table align-items-center table-flush'>
                                                    <thead className='thead-light'>
                                                        <tr>
                                                            <th scope='col'>Username</th>
                                                            <th scope='col'>Full Name</th>
                                                            <th scope='col'>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {datalist?.length > 0 ? datalist?.map((data, i) => {
                                                            return (
                                                                <tr>
                                                                    <th scope='row'>
                                                                        <div className='media align-items-center'>
                                                                            <div className='media-body'>
                                                                                <span className='mb-0 text-sm'>
                                                                                    {data?.userName}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </th>
                                                                    <td>{data?.fullName}</td>
                                                                   <td>{formatIndianNumber(data?.amount)}</td>
                                                                </tr>
                                                            )
                                                        }) : <></>}
                                                    </tbody>
                                                </table>
                                            </>
                                        ) : (
                                            <>
                                                <div className='text-center'>
                                                    <img width={'25%'} src={NoDataImg}></img>
                                                    <br />
                                                    <label style={{ fontWeight: 'bold' }}>
                                                        {LOADING_ENABLE ? (
                                                            <>Loading Data.....</>
                                                        ) : (
                                                            <>No Data Found</>
                                                        )}
                                                    </label>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {datalist && datalist.length > 0 ? (
                                        <div className='card-footer py-4'>
                                            <Box
                                                display='flex'
                                                justifyContent='right'
                                                alignItems='center'
                                            >
                                                <span>Total record: {pagerecord?.totalItems}</span>
                                                <Pagination
                                                    className='custom-pagination-class'
                                                    count={pagerecord?.totalPages}
                                                    page={page}
                                                    onChange={handleChange}
                                                    color='secondary'
                                                />
                                            </Box>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </div>
        </>
    )
}